import axios from "axios";

import {IShipmentMilestone} from "./Shipment.Milestones.types";

export default class ShipmentMilestonesApi {

    static async getShipmentOperationsMilestones({queryKey}: any) {
        let referenceNumber = queryKey[1].referenceNumber;
        try {
            let res = await axios.get(`/Shipments/${referenceNumber}/OperationsMilestones`);
            return res.data as IShipmentMilestone[];
        } catch (e: any) {
            console.error('Could not get shipment operations milestones: ', e.message);
            return undefined;
        }
    }

    static async getShipmentLogisticsMilestones({queryKey}: any) {
        let referenceNumber = queryKey[1].referenceNumber;
        try {
            let res = await axios.get(`/Shipments/${referenceNumber}/LogisticsMilestones`);
            return res.data as IShipmentMilestone[];
        } catch (e: any) {
            console.error('Could not get shipment logistics milestones: ', e.message);
            return undefined;
        }
    }
}